// Vollea — Reusable "Continue with Google" button (Emergent OAuth).
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React from "react";
import { C, SP, R } from "../lib/theme";

export default function GoogleSignInButton({ inviteCode, label = "Continue with Google", testid = "google-signin-button" }) {
  const onClick = () => {
    // Preserve the invite code across the redirect so first-time Google users
    // can still satisfy closed-beta gating when they land back on /auth-callback.
    if (inviteCode) sessionStorage.setItem("vollea_invite_code", inviteCode);
    // Dynamic redirect — exact origin user is on right now. Lands on /auth-callback
    // because AuthCallback also runs from /dashboard, but giving it a dedicated
    // path keeps the URL fragment off protected routes.
    const redirectUrl = window.location.origin + "/auth-callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      style={{
        height: 52, width: "100%", borderRadius: R.md,
        background: "#fff", color: "#1f1f1f",
        border: "1px solid #dadce0", fontWeight: 600, fontSize: 14,
        display: "inline-flex", alignItems: "center", justifyContent: "center", gap: SP.sm,
        cursor: "pointer", transition: "background-color .15s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f6f6f6")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
    >
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
        <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.79 2.72v2.26h2.9c1.7-1.57 2.69-3.88 2.69-6.62z"/>
        <path fill="#34A853" d="M9 18c2.43 0 4.47-.81 5.96-2.18l-2.9-2.26c-.81.54-1.83.86-3.06.86-2.35 0-4.34-1.59-5.05-3.72H.96v2.34A9 9 0 0 0 9 18z"/>
        <path fill="#FBBC05" d="M3.95 10.7a5.41 5.41 0 0 1 0-3.41V4.96H.96a9 9 0 0 0 0 8.08l2.99-2.34z"/>
        <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.34l2.58-2.58A9 9 0 0 0 9 0a9 9 0 0 0-8.04 4.96l2.99 2.34C4.66 5.17 6.65 3.58 9 3.58z"/>
      </svg>
      <span style={{ letterSpacing: 0.3 }}>{label}</span>
    </button>
  );
}
